import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import React from 'react'
import { useAdminOutletContext } from 'routes/paths/admin'

const ValueGetterCliente: React.FC<GridCellParams<number>> = ({ value }) => {
    const { clientes } = useAdminOutletContext()
    if (value === 0) return 'Prosis'

    const cliente = clientes?.find(cliente => cliente.id === value)

    return cliente?.nomeFantasia ?? 'Cliente não encontrado'
}

export default ValueGetterCliente
